/** 成长管理 */

// 成长规则-成长规则列表
export const GROWTH_RULE_LIST = '/cmvip/growthUpApi/getGrowthList';
// 成长规则-成长规则详情
export const GROWTH_RULE_DETAIL = '/cmvip/growthUpApi/getGrowthById';
// 成长规则-修改成长规则状态（启用/停用）
export const ENABLE_GROWTH_RULE = '/cmvip/growthUpApi/updateGrowthStatus';
// 成长规则-添加成长规则
export const ADD_GROWTH_RULE = '/cmvip/growthUpApi/addGrowth';
// 成长规则-编辑成长规则
export const EDIT_GROWTH_RULE = '/cmvip/growthUpApi/updateGrowth';
// 成长值流水-成长值流水列表
export const GROWTH_UPDATE_LIST = '/cmvip/userVipInfo/getGrowRecord';
// 成长值修改-会员成长值列表
export const USER_GROWTH_LIST = '/cmvip/growthUpApi/getUserGrowthList';
// 成长值修改-会员成长值列表-通过手机号查找
export const USER_GROWTH_LIST_BYMOBILE = '/cmvip/userVipInfo/getVipUserByMobile';
// 成长值修改-会员成长值修改
export const EDIT_USER_GROWTH = '/cmvip/growthUpApi/updateUserGrowthValue';
// 成长值修改-会员成长值修改记录
export const GRWTH_EDIT_LIST = '/cmvip/growthUpApi/getGrowUpValueRecordList';
